<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-h5 font-weight-black">
          {{ componentData.continue }}
        </div>
      </v-col>
      <v-col>
        <v-form ref="form" lazy-validation @submit.prevent="">
          <!-- <v-text-field
            outlined
            hide-details="auto"
            v-model="signUpData.name"
            :label="componentData.formSetting.input1.label"
            :placeholder="componentData.formSetting.input1.placeholder"
            :rules="componentData.formSetting.input1.rules"
            :error-messages="componentData.formSetting.input1.errorMsg"
            @focus="ResetErrorValidation"
          ></v-text-field> -->
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signUpData.password"
            :label="componentData.formSetting.input2.label"
            :placeholder="componentData.formSetting.input2.placeholder"
            :rules="componentData.formSetting.input2.rules"
            :error-messages="componentData.formSetting.input2.errorMsg"
            :type="pwdVisiable ? 'text' : 'password'"
            :append-icon="pwdVisiable ? eyeIcon.eyeOff : eyeIcon.eyeOn"
            :hint="componentData.hint"
            persistent-hint
            @click:append="EyeSwitch()"
            @focus="ResetErrorValidation"
          ></v-text-field>
          <div class="py-2"></div>
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signUpData.passwordConfirm"
            :label="componentData.formSetting.input3.label"
            :placeholder="componentData.formSetting.input3.placeholder"
            :rules="componentData.formSetting.input3.rules"
            :error-messages="componentData.formSetting.input3.errorMsg"
            :type="pwdVisiable ? 'text' : 'password'"
            :append-icon="pwdVisiable ? eyeIcon.eyeOff : eyeIcon.eyeOn"
            persistent-hint
            @click:append="EyeSwitch()"
            @focus="ResetErrorValidation"
          ></v-text-field>
        </v-form>
        <div class="py-4"></div>
        <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="SignUp()"
        >
          <span class="mx-2 text-capitalize">{{ componentData.finish }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Account_SignUp, Token_SignIn } from "@/apis/api";
import axios from "axios";

export default {
  name: "SignUp",
  data() {
    return {
      componentData: {
        title: "",
        formSetting: {
          input1: {
            label: "名稱",
            placeholder: "請輸入用戶名稱",
            rules: [(v) => !!v || "此欄位必填"],
            errorMsg: "",
          },
          input2: {
            placeholder: "請輸入密碼",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) => v.length >= 6 || "長度最少需為6個字元",
              (v) => v.length <= 20 || "長度需少於20個字元",
              (v) => /[A-Za-z]+/.test(v) || "至少包含一個英文",
              (v) => /\d+/.test(v) || "至少包含一個數字",
              (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "請輸入英文或數字",
            ],
            errorMsg: "",
          },
          input3: {
            placeholder: "再次確認密碼",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) => v.length >= 6 || "長度最少需為6個字元",
              (v) => v.length <= 20 || "長度需少於20個字元",
              (v) => /[A-Za-z]+/.test(v) || "至少包含一個英文",
              (v) => /\d+/.test(v) || "至少包含一個數字",
              (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "請輸入英文或數字",
            ],
            errorMsg: "",
          },
        },
        hint: "請輸入最少6個字元，混合英數字之密碼",
        finish: "完成",
        continue: "設定密碼",
        loading: false,
      },
      signUpData: {
        email: null,
        password: "",
        passwordConfirm: "",
        name: "",
      },
      invitedQuery: null,
      pwdVisiable: false,
      eyeIcon: {
        eyeOn: "mdi-eye",
        eyeOff: "mdi-eye-off",
      },
    };
  },
  created() {
    this.signUpData.email = this.$route.query.email;

    // 如果有帳號
    if (this.$route.query.acc === "exist") {
      if (this.CheckupSignin()) {
        this.GoFromSite(); // 已登入 => 從哪裡來回哪裡去
        this.GoBackHome();
      } else {
        this.GoSignIn(); // 未登入 => 回登入頁
      }
    }
  },
  methods: {
    // 顯示密碼切換
    EyeSwitch() {
      this.pwdVisiable = !this.pwdVisiable;
    },
    // 清除表單驗證
    ResetErrorValidation() {
      // this.$refs.form.resetValidation();
      this.componentData.formSetting.input2.errorMsg = "";
      this.componentData.formSetting.input3.errorMsg = "";
    },
    // 註冊
    SignUp() {
      // 驗證不過直接回傳
      if (!this.$refs.form.validate()) {
        return false;
      }
      if (this.signUpData.passwordConfirm !== this.signUpData.password) {
        this.componentData.formSetting.input3.errorMsg =
          "兩次密碼輸入不一致，請重新輸入";
        return false;
      }
      this.componentData.loading = true;
      // api;
      Account_SignUp(this.signUpData)
        .then((res) => {
          console.log(res.data.message);
          this.componentData.loading = false;
          // 註冊完就直接登入token
          this.SignIn();
        })
        .catch((err) => {
          this.componentData.loading = false;
          this.componentData.formSetting.input1.errorMsg =
            err.response.data.message;
        });
    },
    // Google recaptcha v3
    async GetRecaptchaToken() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("login");
      return token;
    },
    // 登入
    async SignIn() {
      let signInDate = {
        email: this.signUpData.email,
        password: this.signUpData.password,
        recaptchaToken: "",
      };
      signInDate.recaptchaToken = await this.GetRecaptchaToken();
      // api
      Token_SignIn(signInDate)
        .then((res) => {
          console.log(res.data);
          localStorage.setItem("_token", res.data.token);
          localStorage.setItem("_acc", this.signUpData.email);
          localStorage.setItem("_pwd", this.signUpData.password);
          this.GetEmailEncrypt(res.data.token);
          this.$emit("token", res.data.token);
          this.invitedQuery = res.data.invitedQuery;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.message === "無此帳號，請重新輸入") {
            // 帳號錯
            this.componentData.formSetting.input1.errorMsg =
              err.response.data.message;
          } else {
            // 密碼錯
            this.componentData.formSetting.input2.errorMsg =
              err.response.data.message;
          }

          this.componentData.loading = false;
        });
    },
    // 檢查登入狀態
    CheckupSignin() {
      return this.$store.state.signinStatus;
    },
    // 取得加密email
    GetEmailEncrypt(token) {
      const apiBaseUrl = process.env.VUE_APP_MAIN_API_BASE_URL;
      const header = {
        Authorization: "Bearer " + token,
      };
      const myRequest = axios.create({
        baseURL: apiBaseUrl,
        headers: header,
      });
      myRequest
        .get(`Token/emailEncrypt`)
        .then((res) => {
          this.componentData.loading = false;
          this.GoFromSite(res.data);
          //   this.GoSignUpSuccess(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // // 轉註冊成功頁面
    // GoSignUpSuccess(email) {
    //   this.$emit("switch", "SignUpSuccess");
    //   localStorage.setItem("_emailEncrypt", email);
    // },
    // 從哪來回哪去
    GoFromSite(emailEncrypt) {
      if (this.invitedQuery) {
        window.location.replace(
          ` ${this.$store.state.fromSite.url}/writeInvitedForm?emailEncrypt=${emailEncrypt}&${this.invitedQuery}`
        );
      } else {
        let fromCmid = localStorage.getItem("fromCmid");
        if (fromCmid) {
          localStorage.removeItem("fromCmid");
          window.location.replace(
            `${this.$store.state.fromSite.url}/writeInvitedForm?cmid=${fromCmid}&uem=${emailEncrypt}`
          );
        } else {
          window.location.replace(
            this.$store.state.fromSite.url + "?emailEncrypt=" + emailEncrypt
          );
        }
      }
    },
    GoBackHome() {
      this.$router.push({ name: "Home" });
    },
    GoSignIn() {
      this.$emit("switch", "SignIn");
      this.$router.push({ name: "SignIn" });
    },
  },
};
</script>
